const { Tracker } = require('@reverbdotcom/discovery-ui');

const React = require('react');
const ReactDOM = require('react-dom');
const Photo = require('components/photos/photo.js');
const PhotoEditor = require('components/photos/editor.jsx');

class DropzoneMessageManager {
  constructor($message, $dropbox) {
    this.$message = $message;
    this.$dropbox = $dropbox;
    const ie_message = $message.find('[rel=dropbox-ie-message]');
    const non_ie_message = $message.find('[rel=dropbox-non-ie-message]');
    const ff_message = $message.find('[rel=dropbox-firefox-message]');

    if ($.browser.msie) {
      ie_message.show();
    } else if ($.browser.mozilla) {
      this._linkMessageClickToFileInput();
      ff_message.show();
    } else {
      non_ie_message.show();
    }

    this.$message.prop('originalValue', this.$message.html());
  }

  set(text) {
    this.$message.html(text);
  }

  restore() {
    this.$message.html(this.$message.prop('originalValue'));
  }

  _linkMessageClickToFileInput() {
    this.$message.click(function (e) {
      if (e.currentTarget === this && e.target.nodeName !== 'INPUT') {
        $(this.control).click();
      }
    });

    this.$message.height(this.$dropbox.height());
  }
}

class AttachinaryDropzone {
  constructor($dropbox) {
    this.$dropbox = $dropbox;
    this.$container = $dropbox.parents('[data-upload-container]');
    this.$progressBar = this.$dropbox.find('[rel=dropbox-progress-bar]');
    this.$photoContainer = this.$dropbox.find('[rel=photo-container]');
    this.$attachinaryInput = this.$dropbox.find('input.attachinary-input');
    this.$smallPhotoWarning = this.$container.find('[data-small-photo-warning]');
    this.$smallPhotoError = this.$container.find('[data-small-photo-error]');
    this.$smallPhotoErrorClose = this.$smallPhotoError.find('[data-close-small-photo-error]');
    this.singleFileDropzone = $dropbox.hasClass('single-file');
    this.pluralizedPhotos = this.singleFileDropzone ? 'photo' : 'photos';
    this.dropzoneMessage = new DropzoneMessageManager(this.$dropbox.find('label[rel=message]'), this.$dropbox);
    this.shouldDisableDragDrop = ($.browser.mozilla || $.browser.msie);
    this.showImageDimensionWarning = this.$dropbox.data('show-image-dimension-warning') != undefined;
    this.eventNamespace = this.$dropbox.data('event-namespace');
    this.dropzoneHadFilesBeforeDragover = false;

    if (this.shouldDisableDragDrop) { this.$dropbox.find('[rel=dragdrop-disabled]').show(); }

    $.attachinary.config.template = this.$dropbox.find('script[type=\'text/template\']').html();
    $.attachinary.config.disableWith = null;

    this.bindEventHandlers(this.$attachinaryInput);

    if (this.$dropbox.hasClass('has-files')) {
      this.showPhotos();
      this.handleThumbnailReorder();
    }

    this.displayHasFilesMessage();

    this.bindDropzoneDragover();
    this.bindBodyDragover();
    this.bindEditPhoto();
  }

    // When someone starts hovering over the body,
    // enlarge the dropzone so it's harder to miss
  bindBodyDragover() {
    $('body').on({
      dragenter: (e) => {
        this.enlargeDroppableArea();
        this.onDragOver(e);
        this.stopProp(e);
      },
      dragover: () => this.stopProp,
      dragexit: () => this.stopProp,
      drop: (e) => {
        this.checkForDisabledDragDrop();
        this.stopProp(e);
      },
    });
  }

  bindEditPhoto() {
    $(this.$dropbox).on('click', '[data-edit-photo]', (e) => {
      e.preventDefault();
      const $btn = $(e.target);
      const photo = new Photo($btn.data('edit-photo'));
      this.openPhotoEditor(photo);
    });
  }

  openPhotoEditor(photo) {
    const props = {
      photo,
      onUpdatePhoto: (updatedPhoto) => this.handleUpdatePhoto(updatedPhoto),
      onCloseEditor: () => this.handleCloseEditor(),
    };
    const photoEditor = React.createElement(PhotoEditor, props, null);

    const editorContainer = document.getElementById('react_photo_editor');
    editorContainer.innerHTML = '';

    ReactDOM.render(photoEditor, editorContainer, () =>
      $.fancybox(document.getElementById('react_photo_editor'))
    );
  }

  handleUpdatePhoto(photo) {
    // 1. update thumb
    const $img = this.attachinaryContainerImages().filter(function () {
      return $(this).data('public-id') === photo.public_id;
    }).first();
    $img.attr('src', photo.thumbUrl);

    // 2. update form input
    const inputPhotos = JSON.parse(this.photosInput().val());
    const inputPhoto = inputPhotos.find(p => p.public_id === photo.public_id);

    inputPhoto.transformation = photo.userTransformation;

    this.photosInput().val(JSON.stringify(inputPhotos));

    // 3. Update photo in edit link data attr
    const $editLink = this.editPhotoLinks().
      filter(function () { return $(this).data('public-id') === photo.public_id; }).
      first();
    $editLink.data('edit-photo', photo);

    // 4. Update internal files within the attachinary plugin, so that
    // when it redraws, it keeps any changes to crops etc
    const index = this.attachinary.files.findIndex(file => file.public_id === photo.public_id);
    this.attachinary.files[index] = photo;

    // 5. close editor
    this.handleCloseEditor();
  }

  editPhotoLinks() {
    return this.attachinaryContainer().find('[data-edit-photo]');
  }

  handleCloseEditor() {
    $.fancybox.close();
  }

  // Firefox doesn't do well with the drop event because
  // the input cannot be styled to be larger than it truly is.
  // That means if you drop anywhere outside the actual file input,
  // the upload will not work. To make that work would require somehow
  // forwarding the drop event and the correct e.dataTransfer to the
  // fileupload plugin itthis, which would require hacking its internals.
  checkForDisabledDragDrop() {
    if (this.shouldDisableDragDrop) {
      this.dropzoneMessage.set('Sorry, we can\'t drag & drop in your browser. Please try Google Chrome or <span class=\'clickable\'>click here</span> to upload files.');
    }
  }

  stopProp(e) {
    e.stopPropagation();
    e.preventDefault();
    return false;
  }

  bindDropzoneDragover() {
    this.$dropbox.on({
      'dragenter': (e) => {
        this.onDragOver(e);
        return false;
      }, 'dragleave': (e) => {
        this.$dropbox.removeClass('hover');
        this.restoreDropzoneSize();
        this.stopProp(e);
        return false;
      }, 'drop': (e) => {
        this.restoreDropzoneSize();
        this.checkForDisabledDragDrop();
        this.stopProp(e);
        return false;
      } });
  }

  enlargeDroppableArea() {
    this.$attachinaryInput.width('10000px');
    this.$attachinaryInput.height('10000px');
    this.$attachinaryInput.css({ 'top': 0, 'left': 0, 'position': 'fixed' });
  }

  onDragOver(e) {
    if (this.shouldDisableDragDrop) { return; } // no drag in firefox

    this.dropzoneMessage.set('Drop your ' + this.pluralizedPhotos + ' here.');
    this.dropzoneHadFilesBeforeDragover = this.hasFiles();
    this.$dropbox.addClass('hover');

    this.stopProp(e);
  }

  restoreDropzoneSize() {
    this.dropzoneMessage.restore();

    if (this.dropzoneHadFilesBeforeDragover) { this.showPhotos(); }

    this.$dropbox.height('auto');
    this.$attachinaryInput.css({ 'top': '', 'left': '', 'position': 'absolute', 'width': 'auto', 'height': '100%' });
  }

  showPhotos() {
    this.$photoContainer.show();
    this.$dropbox.addClass('has-files');
    this.attachinaryContainer().appendTo(this.$photoContainer);
  }

  hidePhotos() {
    this.$photoContainer.hide();
    this.$dropbox.removeClass('has-files');
  }

  parseThumbnailOrder() {
    if (!this.hasManyFiles()) { return true; }

    let photos = $(JSON.parse(this.photosInput().val()));

    let sortedPhotos = this.attachinaryContainerImages().map(function (index) {
      let photoId = $(this).data('public-id');
      let photo = photos.filter(function () { return this.public_id == photoId; })[0];

      return { position: index, public_id: photo.public_id };
    });

    let form = this.attachinaryContainerForm();

    $(sortedPhotos).each(function () {
      var input = $('<input type=\'hidden\' name=\'photo_order[' + this.public_id + ']\'/>').val(this.position);
      form.append(input);
    });

    return true;
  }

  attachinaryContainer() {
    return this.$dropbox.find('.attachinary_container');
  }

  attachinaryContainerImages() {
    return this.attachinaryContainer().find('img');
  }

  attachinaryContainerForm() {
    return this.attachinaryContainer().parents('form');
  }

  photosInput() {
    return this.$dropbox.find('input[type=hidden]');
  }

  handleThumbnailReorder() {
    if (this.singleFileDropzone) { return; } // don't operate on single-file dropzones
    this.attachinaryContainer().find('[data-thumb-container]').sortable();
  }

  checkFileDimensions() {
    const self = this;
    const minimumDimension = 620;
    let smallPhoto = false;

    this.attachinaryContainerImages().each(function () {
      const img = $(this);

      if (self.imageTooSmall(img, minimumDimension)) {
        smallPhoto = true;
        img.parent('li').addClass('error');
        img.parent('li').append('<p class=\'overlay small-image-warning\'><i class=\'fa fa-exclamation-triangle\'><\/i></p>');
        self.track('image_dimension_warning');
      }
    });

    this.$smallPhotoWarning.toggle(smallPhoto);
  }

  validateMinimumDimensions() {
    const that = this;
    const minimumDimension = 200;
    const $img = this.attachinaryContainerImages().last();

    if (this.imageTooSmall($img, minimumDimension)) {
      $img.parent('li').find('[data-remove]').trigger('click');
      this.$smallPhotoError.show();
      this.track('image_too_small');

      this.$smallPhotoErrorClose.on('click.imageError', function () {
        that.$smallPhotoError.hide();
      });
    } else {
      this.$smallPhotoError.hide();
    }
  }

  imageTooSmall($img, minimumDimension) {
    const width = $img.data('orig-width');
    const height = $img.data('orig-height');

    return (parseInt(width, 10) < minimumDimension) || (parseInt(height, 10) < minimumDimension);
  }

  displayHasFilesMessage() {
    if (! this.singleFileDropzone) { return; } // this is only for single file dropzones

    if (this.hasFiles()) {
      this.$dropbox.find('.no-files-message').hide();
    } else {
      this.$dropbox.find('.no-files-message').show();
    }
  }

  hasFiles() {
    return this.attachinaryContainerImages().length > 0;
  }

  hasManyFiles() {
    return this.attachinaryContainerImages().length > 1;
  }

  bindEventHandlers(selector) {
    const $attachinary = selector.attachinary({ sequentialUploads: false });
    this.attachinary = $attachinary.data('attachinary-bond');

    selector.bind('fileremoved', () => this.onFileRemoved());
    selector.bind('fileuploaddragover', (e) => this.onDragOver(e));
    selector.bind('fileuploadadd', () => this.showPhotos());
    selector.bind('fileuploaddone', (e) => this.onFileUploadDone(e));
    selector.bind('fileuploadstop', () => this.onFileUploadsAllDone());
    selector.bind('fileuploadprogressall', (e, data) => this.onFileUploadProgress(e, data));
    selector.parents('form').bind('submit', () => {
      this.parseThumbnailOrder();
      return true;
    });
  }

  onFileUploadsAllDone() {
    this.setProgressBarPercent(100);
    setTimeout(() => this.hideProgressBar(), 250);
  }

  onFileUploadDone() {
    this.track('upload_complete');

    if (this.showImageDimensionWarning) {
      this.validateMinimumDimensions();
      this.checkFileDimensions();
    }
    this.handleThumbnailReorder();
    this.displayHasFilesMessage();
  }

  onFileRemoved() {
    this.checkFileDimensions();
    this.displayHasFilesMessage();
    this.handleThumbnailReorder();

    if (!this.hasFiles()) { this.hidePhotos(); }
  }

  onFileUploadProgress(e, data) {
    // There is a bit of delay between the last fileuploadprogress event, and
    // the time when all file uploads finish (in fileuploadstop). To avoid
    // the progress bar prematurely disappearing, we will move it to the 90%
    // mark here, and finish the last bit inside the event when all uploads complete.
    const almostFullPercent = 90;

    this.showPhotos();

    const ratio = this.progressRatio(data);

    this.setProgressBarPercent(almostFullPercent * ratio);
  }

  setProgressBarPercent(percent) {
    this.$progressBar.html('<div class=\'dropbox-progress-bar\' style=\'width:' + percent + '%\'><span class=\'fa fa-spin fa-spinner\'></span> Uploading...</div>');
    this.$progressBar.show();
  }

  hideProgressBar() {
    this.$progressBar.fadeOut();
  }

  progressRatio(data) {
    return parseFloat(data.loaded) / parseFloat(data.total);
  }

  track(key) {
    if (this.eventNamespace) {
      Tracker.trackInteraction({ name: this.eventNamespace, interaction: key });
    }
  }
}

$(function () {
  if ($('.dropbox').length > 0) {
    $('.dropbox').each(function (index, el) {
      new AttachinaryDropzone($(el));
    });
  }
});

module.exports = AttachinaryDropzone;



// WEBPACK FOOTER //
// ./javascripts/components/reverb.attachinary.js